import client from "./client";

const base = "/accounting";

export const impairAsset = async (assetId, body) =>
  (await client.post(`${base}/assets/${assetId}/impair`, body)).data;

export const listLeases = async () => (await client.get(`${base}/leases`, { params: { status: "all" } })).data;
export const createLease = async (body) => (await client.post(`${base}/leases`, body)).data;
export const runLeaseMonth = async (month) => (await client.post(`${base}/leases/monthly`, { month })).data;
export const closeLease = async (id) => (await client.post(`${base}/leases/${id}/close`)).data;

export const listItems = async () => (await client.get(`${base}/inventory`)).data;
export const createItem = async (body) => (await client.post(`${base}/inventory`, body)).data;
export const listMoves = async (item_id) => (await client.get(`${base}/inventory/moves`, { params: { item_id } })).data;
export const receiveStock = async (body) => (await client.post(`${base}/inventory/receive`, body)).data;
export const issueStock = async (body) => (await client.post(`${base}/inventory/issue`, body)).data;

export const eosPreview = async (month) => (await client.get(`${base}/eos/${month}`)).data;
export const eosAccrue = async (month) => (await client.post(`${base}/eos`, { month })).data;
